/*
 * RouteProvider.js (context: "RAP4"). Generated code, edit with care.
 */
/* jshint ignore:start */
angular.module('AmpersandApp').config( function ($routeProvider) {
    $routeProvider
    .when( "/AccRegForm/:resourceId?", {
        controller:  "IfcAccRegFormController",
        templateUrl: "app/project/ifcAccRegForm.view.html",
        interfaceLabel: "AccRegForm" 
        }
    )
    .when( "/Account/:resourceId?", {
        controller:  "IfcAccountController",
        templateUrl: "app/project/ifcAccount.view.html",
        interfaceLabel: "Account" 
        }
    )
    .when( "/Accounts/:resourceId?", {
        controller:  "IfcAccountsController",
        templateUrl: "app/project/ifcAccounts.view.html",
        interfaceLabel: "Accounts" 
        }
    )
    .when( "/Atlas/:resourceId?", {
        controller:  "IfcAtlasController",
        templateUrl: "app/project/ifcAtlas.view.html",
        interfaceLabel: "Atlas" 
        }
    )
    .when( "/Concept/:resourceId?", {
        controller:  "IfcConceptController",
        templateUrl: "app/project/ifcConcept.view.html",
        interfaceLabel: "Concept" 
        }
    )
    .when( "/Context/:resourceId?", {
        controller:  "IfcContextController",
        templateUrl: "app/project/ifcContext.view.html",
        interfaceLabel: "Context" 
        }
    )
    .when( "/ContextDetailed/:resourceId?", {
        controller:  "IfcContextDetailedController",
        templateUrl: "app/project/ifcContextDetailed.view.html",
        interfaceLabel: "ContextDetailed" 
        }
    )
    .when( "/Edit_32_interface/:resourceId?", {
        controller:  "IfcEdit_32_interfaceController",
        templateUrl: "app/project/ifcEdit_32_interface.view.html",
        interfaceLabel: "Edit interface" 
        }
    )
    .when( "/Edit_32_menu_32_item/:resourceId?", {
        controller:  "IfcEdit_32_menu_32_itemController",
        templateUrl: "app/project/ifcEdit_32_menu_32_item.view.html",
        interfaceLabel: "Edit menu item" 
        }
    )
    .when( "/Edit_32_navigation_32_menu/:resourceId?", {
        controller:  "IfcEdit_32_navigation_32_menuController",
        templateUrl: "app/project/ifcEdit_32_navigation_32_menu.view.html",
        interfaceLabel: "Edit navigation menu" 
        }
    )
    .when( "/Language/:resourceId?", {
        controller:  "IfcLanguageController",
        templateUrl: "app/project/ifcLanguage.view.html",
        interfaceLabel: "Language" 
        }
    )
    .when( "/List_32_all_32_interfaces/:resourceId?", {
        controller:  "IfcList_32_all_32_interfacesController",
        templateUrl: "app/project/ifcList_32_all_32_interfaces.view.html",
        interfaceLabel: "List all interfaces" 
        }
    )
    .when( "/Login/:resourceId?", {
        controller:  "IfcLoginController",
        templateUrl: "app/project/ifcLogin.view.html",
        interfaceLabel: "Login" 
        }
    )
    .when( "/Logout/:resourceId?", {
        controller:  "IfcLogoutController",
        templateUrl: "app/project/ifcLogout.view.html",
        interfaceLabel: "Logout" 
        }
    )
    .when( "/MyAccount/:resourceId?", {
        controller:  "IfcMyAccountController",
        templateUrl: "app/project/ifcMyAccount.view.html",
        interfaceLabel: "MyAccount" 
        }
    )
    .when( "/MyScripts/:resourceId?", {
        controller:  "IfcMyScriptsController",
        templateUrl: "app/project/ifcMyScripts.view.html",
        interfaceLabel: "MyScripts" 
        }
    )
    .when( "/Nieuw_32_script/:resourceId?", {
        controller:  "IfcNieuw_32_scriptController",
        templateUrl: "app/project/ifcNieuw_32_script.view.html",
        interfaceLabel: "Nieuw script" 
        }
    )
    .when( "/Overview/:resourceId?", {
        controller:  "IfcOverviewController",
        templateUrl: "app/project/ifcOverview.view.html",
        interfaceLabel: "Overview" 
        }
    )
    .when( "/PF__AllRoles/:resourceId?", {
        controller:  "IfcPF__AllRolesController",
        templateUrl: "app/project/ifcPF__AllRoles.view.html",
        interfaceLabel: "PF_AllRoles" 
        }
    )
    .when( "/PF__MenuItems/:resourceId?", {
        controller:  "IfcPF__MenuItemsController",
        templateUrl: "app/project/ifcPF__MenuItems.view.html",
        interfaceLabel: "PF_MenuItems" 
        }
    )
    .when( "/Pattern/:resourceId?", {
        controller:  "IfcPatternController",
        templateUrl: "app/project/ifcPattern.view.html",
        interfaceLabel: "Pattern" 
        }
    )
    .when( "/Patterns/:resourceId?", {
        controller:  "IfcPatternsController",
        templateUrl: "app/project/ifcPatterns.view.html",
        interfaceLabel: "Patterns" 
        }
    )
    .when( "/PropRule/:resourceId?", {
        controller:  "IfcPropRuleController",
        templateUrl: "app/project/ifcPropRule.view.html",
        interfaceLabel: "PropRule" 
        }
    )
    .when( "/Register/:resourceId?", {
        controller:  "IfcRegisterController",
        templateUrl: "app/project/ifcRegister.view.html",
        interfaceLabel: "Register" 
        }
    )
    .when( "/Relation/:resourceId?", {
        controller:  "IfcRelationController",
        templateUrl: "app/project/ifcRelation.view.html",
        interfaceLabel: "Relation" 
        }
    )
    .when( "/Roles/:resourceId?", {
        controller:  "IfcRolesController",
        templateUrl: "app/project/ifcRoles.view.html",
        interfaceLabel: "Roles" 
        }
    )
    .when( "/Rule/:resourceId?", {
        controller:  "IfcRuleController",
        templateUrl: "app/project/ifcRule.view.html",
        interfaceLabel: "Rule" 
        }
    )
    .when( "/StudentScripts/:resourceId?", {
        controller:  "IfcStudentScriptsController",
        templateUrl: "app/project/ifcStudentScripts.view.html",
        interfaceLabel: "StudentScripts" 
        }
    )
});
/* jshint ignore:end */